import { memo, useState } from 'react';
import { Runner } from 'react-runner';

import Alert from '@/components/Alert';

import Imports from './Imports';

const createMockAPIs = () => {
  return {
    updateElement: async (
      _nextProps: Record<string, any>
    ): Promise<{ success: boolean }> => {
      return { success: true };
    },

    deleteElement: async (): Promise<{ success: boolean }> => {
      return { success: true };
    },

    callAction: async (action: {
      name: string;
      payload: Record<string, unknown>;
    }): Promise<{ success: boolean }> => {
      void action;
      return { success: true };
    },

    sendUserMessage: (_message: string): void => {
      // This renderer is used outside a live chat session; interactions are
      // intentionally inert and must not leak payloads to the browser console.
    }
  };
};

const Renderer = memo(function ({
  sourceCode,
  props
}: {
  sourceCode: string;
  props: Record<string, unknown>;
}) {
  const [error, setError] = useState<string>();

  if (error) return <Alert variant="error">{error}</Alert>;

  if (!sourceCode) return null;

  const mockedApis = createMockAPIs();

  return (
    <Runner
      code={sourceCode}
      scope={{
        import: Imports,
        props,
        ...mockedApis
      }}
      onRendered={(error) => setError(error?.message)}
    />
  );
});

export { Renderer };
